<ts-asset-card
  header="{{ 'device_to_upgrade' | translate }}"
  [asset]="asset"
  [asset_fields]="['plan', 'add_on_features', 'contract_end_date', 'upgrade_eligible_date']"
  [card_wrap]="card_wrap"
  [class]="class"
  [extras]="keep_plan"
>
  <ng-template #cardExtraContent *ngIf="order_type_settings?.can_keep_plan">
    <div class="mt-3">
      <h6>
        {{ 'keep_old_plans_and_features' | translate }}
      </h6>
      <span>
        {{
          keep_plan
            ? ('keep_old_plans_and_features_yes' | translate)
            : ('keep_old_plans_and_features_no' | translate)
        }}
      </span>
    </div>
  </ng-template>
</ts-asset-card>
